
import { Link } from "react-router-dom";
import classes from "./AboutPolldock.module.css";

function AboutPolldock() {
  //
  // Define a function for forcing the scroll position to reset.
  const scrollResetHandler = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <h2 className={classes.aboutPolldock_h2}>
        What is Polldock?
      </h2>
      <div className={classes.aboutPolldock_textBlock}>
        Polldock is an interactive collection of poll questions covering a wide
        range of topics, from sports and entertainment to culture and lifestyle,
        and beyond. By submitting your own responses to these questions and
        exploring the results from multiple angles, you can engage with the
        opinions and experiences of others in a fun and interesting way.
      </div>
      <div className={classes.aboutPolldock_textBlock}>
        New polls are being added all the time, so be sure to check back
        regularly for new questions.
      </div>
      <h2 className={classes.aboutPolldock_h2}>
        How does it work?
      </h2>
      <div className={classes.aboutPolldock_textBlock}>
        Our home page shows a list of all of our poll questions, which you can
        also browse by category. Select a question and choose your answer from
        several available choices. Once you submit your answer, you can see the
        results for that question. We'll give you the overall distribution of
        responses as well as various views broken out by sex, decade of birth,
        and state of residence.
      </div>
      <div className={classes.aboutPolldock_textBlock}>
        You will be asked to submit your sex, decade of birth, and state on your
        first visit so that we may include your responses in these dynamic
        views. This is the only information we will collect from you. We do not
        ask your name or any other personally identifiable information. You will
        not need to provide this information every time you submit a poll
        response.
      </div>
      <h2 className={classes.aboutPolldock_h2}>
        Why should I use Polldock?
      </h2>
      <div className={classes.aboutPolldock_textBlock}>
        From time to time you must think "I bet most people agree with me
        about…" or "I'm probably in the minority when it comes to…". We are here
        to satisfy those curiosities.
      </div>
      <div className={classes.aboutPolldock_textBlock}>
        Do you prefer the window seat on a plane? How many other people share
        that opinion? Are there more people who like the aisle? Maybe some even
        prefer the middle! Come find out. This is just one of our many fun poll
        questions.
      </div>
      <div className={classes.aboutPolldock_textBlock}>
        We encourage you to share our poll questions with friends and family.
        The more people answering polls on Polldock, the more information you
        will have in viewing the results. Feel free to share question links
        directly with others or post them on social media. Help us spread the
        word!
      </div>
      <h2 className={classes.aboutPolldock_h2}>
        Is it free?
      </h2>
      <div className={classes.aboutPolldock_textBlock}>
        Yes! The site is completely free and easy to use.
      </div>
      <h2 className={classes.aboutPolldock_h2}>
        Who can use Polldock?
      </h2>
      <div className={classes.aboutPolldock_textBlock}>
        The site is for users who are 18 and older. At present, it is only
        available to users within the United States.
      </div>
      <h2 className={classes.aboutPolldock_h2}>
        Do I need a user account?
      </h2>
      <div className={classes.aboutPolldock_textBlock}>
        No, there is no account or login associated with our site.
      </div>
      <div className={classes.aboutPolldock_textBlock}>
        We do ask that you provide your sex, decade of birth, and state of
        residence on your first visit. This allows us to provide interesting
        views of the results for each poll question. Do younger people tend to
        like their steak cooked differently than older people? In which parts of
        the country do people most tend to prefer cats over dogs? These are just
        a couple of examples of the things you might discover while exploring
        our poll questions.
      </div>
      <h2 className={classes.aboutPolldock_h2}>
        How can I share Polldock with others?
      </h2>
      <div className={classes.aboutPolldock_textBlock}>
        Feel free to share or post the link to our homepage{" ("}
        <a
          className={classes.aboutPolldock_link}
          href="https://polldock.com"
        >
          https://polldock.com
        </a>
        {") "}or the link to a specific question that you want others to see
        {" ("}
        <a
          className={classes.aboutPolldock_link}
          href="https://polldock.com/#/answer-question/14/"
        >
          https://polldock.com/#/answer-question/14/
        </a>
        {" "}for example{")"}. You can also share or post a link to a question's
        results{" ("}
        <a
          className={classes.aboutPolldock_link}
          href="https://polldock.com/#/question-results/14/"
        >
          https://polldock.com/#/question-results/14/
        </a>
        {" "}for example{")"}. If the user visiting the link has not already
        answered that question, he will be rerouted to the "answer question"
        page.
      </div>
      <div className={classes.aboutPolldock_textBlock}>
        Feel free to screenshot interesting results to share on social media,
        but please be sure to include the question link in your post as well.
      </div>
      <div className={classes.aboutPolldock_infoPagesDividerLine}></div>
      <div className={classes.aboutPolldock_infoPagesDiv}>
        <Link
          to="/terms-and-conditions/"
          className={classes.aboutPolldock_infoPagesLink}
          onClick={() => {
            scrollResetHandler();
          }}
        >
          Terms and conditions
        </Link>
        <Link
          to="/privacy-policy/"
          className={classes.aboutPolldock_infoPagesLink}
          onClick={() => {
            scrollResetHandler();
          }}
        >
          Privacy policy
        </Link>
      </div>
      <div className={classes.aboutPolldock_bottomPadding}></div>
    </div>
  );
}

export default AboutPolldock;
